import state from "./state";
import * as actions from "./actions";
import * as mutations from "./mutations";

const SipMovil_store = {
  namespaced: true,
  actions,
  mutations,
  state,
}

export default SipMovil_store